module.exports = __webpack_public_path__ + "static/media/learn-more-slp-image-0.567a7398.jpg";